'use strict';
const angular = require('angular');

export class reservationWidgetComponent {

  constructor($uibModal, ReservationService, Auth, dialogs, Config, $location) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.ReservationService = ReservationService;
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$location = $location;

    this.config = Config.getModuleConfig(Config.Modules.Reservation).getSettings();

    this.eventSources =  [];
    var eventSource = {
      events: []
    };

    this.eventSources.push(eventSource);

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: true,
        defaultView: 'listWeek',
        header: {
          left: '',
          center: '',
          right: ''
        },
        eventClick: (calendarEvent, jsEvent, view) => {
          this.$location.url(calendarEvent.url);
        }
      }
    };

  }

  $onInit() {

    let nowMillis = (new Date()).getTime();

    this.ReservationService.getByUser({user: this.Auth.getCurrentUserSync()._id}, data => {
      data.forEach(evt => {

        let event = {};

        if (!evt.event) {
          event.title = this.config[evt.type].name;
          event.start = evt.start;
          event.end = evt.end;

          event.url = "/reservation/" + evt.type + "/list";
        } else {
          event.title = evt.event.title;
          event.start = evt.event.start;
          event.end = evt.event.end;

          event.url = "/event-reservation/" + evt.event._id;
        }

        if (evt.state == 'accepted' && new Date(event.start).getTime() > nowMillis) {
          this.eventSources[0].events.push(event);
        }

      });
    }, err => {
      console.log('could not retrieve newest events');
    }) ;
  }
}

export default angular.module('conduuApp.reservationWidget', [])
  .component('reservationWidget', {
    template: `<div id="reservationCalendarMain" ui-calendar="$ctrl.uiConfig.calendar" class="span8 calendar" ng-model="$ctrl.eventSources"></div>`,
    bindings: {
     count: '@',
     public: '<'
    },
    controller: reservationWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/reservation-widget/reservation-widget.component.js